export const ETimerTypes = Object.freeze({
  MANUAL: 1,
  FACTORY: 2,
  SIMPLIFIED: 3,
});
